import { useMutation } from '@tanstack/react-query';
import {
  feedbackService,
  Feedback,
} from '@/lib/api/services/feedbackService.ts';
import { message } from 'antd';

// create new feedback
export const useCreateFeedback = () => {
  return useMutation({
    mutationFn: async (payload: Feedback) => {
      return await feedbackService.createFeedback(payload);
    },
    onSuccess: (data) => {
      message.success(data.message);
    },
    onError: (error: any) => {
      message.error(
        error.response?.data?.message || 'Failed to submit feedback'
      );
    },
  });
};
